// 英文语言包
export default {
  // 通用
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    submit: 'Submit',
    reset: 'Reset',
    search: 'Search',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    remove: 'Remove',
    save: 'Save',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    prev: 'Previous',
    loading: 'Loading...',
    noData: 'No Data',
    operation: 'Operation',
    status: 'Status',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    actions: 'Actions',
    success: 'Success',
    fail: 'Failed',
    warning: 'Warning',
    error: 'Error',
    tips: 'Tips',
    pleaseSelect: 'Please Select',
    pleaseInput: 'Please Input',
    normal: 'Normal',
    disabled: 'Disabled'
  },

  // 登录相关
  login: {
    title: 'Login',
    personalLogin: 'Personal Login',
    enterpriseLogin: 'Enterprise Login',
    username: 'Username',
    password: 'Password',
    phone: 'Phone',
    verifyCode: 'Verify Code',
    getVerifyCode: 'Get Verify Code',
    rememberMe: 'Remember Me',
    forgotPassword: 'Forgot Password',
    loginButton: 'Login',
    register: 'Register',
    logout: 'Logout'
  },

  // 用户中心
  userCenter: {
    title: 'User Center',
    account: 'Account Management',
    message: 'Messages',
    approval: 'My Approvals',
    identity: 'Identity Verification',
    admin: 'Enterprise Admin'
  },

  // 消息相关
  message: {
    title: 'Messages',
    unread: 'Unread',
    read: 'Read',
    starred: 'Starred',
    all: 'All',
    system: 'System Message',
    business: 'Business Message',
    activity: 'Activity Message',
    noMessage: 'No Message',
    noMessageDetail: 'No Message Detail',
    markAsRead: 'Mark as Read',
    markAsUnread: 'Mark as Unread',
    star: 'Star',
    unstar: 'Unstar',
    delete: 'Delete Message',
    time: 'Time',
    sender: 'Sender'
  },

  // 审批相关
  approval: {
    title: 'My Approvals',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    applicant: 'Applicant',
    approver: 'Approver',
    businessType: 'Business Type',
    approvalStatus: 'Approval Status',
    remark: 'Remark',
    approve: 'Approve',
    reject: 'Reject',
    approvalTime: 'Approval Time',
    sendApproval: 'Send Approval',
    approvalResult: 'Approval Result'
  },

  // 工作台
  workbench: {
    title: 'Workbench',
    salesman: 'Salesman Management',
    user: 'User Management',
    addSalesman: 'Add Salesman',
    salesmanName: 'Salesman Name',
    idCard: 'ID Card',
    phone: 'Phone',
    inviteTime: 'Invite Time',
    removeSalesman: 'Remove Salesman',
    confirmRemoveSalesman: 'Are you sure to remove salesman "{name}"?',
    removeSuccess: 'Delete Success',
    removeFail: 'Delete Failed, please try again',
    inviteSuccess: 'Approval request has been sent, waiting for confirmation',
    inviteFail: 'Failed to send approval request, please try again',
    serialNumber: 'Serial No',
    loadListFail: 'Failed to load salesman list',
    cannotGetEnterpriseInfo: 'Cannot get current enterprise information',
    inviteSalesmanRemark: 'Invite {name} to become a salesman',
    placeholderSalesmanName: 'Please enter salesman name',
    placeholderPhone: 'Please enter phone number',
    statusChangeSuccess: 'Status updated successfully',
    statusChangeFail: 'Failed to update status, please try again',
    enable: 'Enable',
    disable: 'Disable',
    confirmStatusChange: 'Are you sure to {status} the salesman "{name}"?'
  },

  // 企业管理员
  enterpriseAdmin: {
    title: 'Enterprise Admin',
    addAdmin: 'Invite Admin',
    refresh: 'Refresh',
    adminName: 'Admin Name',
    adminPhone: 'Admin Phone',
    adminStatus: 'Admin Status',
    adminType: 'Admin Type',
    removeAdmin: 'Remove Admin',
    confirmRemoveAdmin: 'Are you sure to remove admin "{name}"?',
    removeSuccess: 'Remove Success',
    removeFail: 'Remove Failed, please try again',
    statusChangeSuccess: 'Status updated successfully',
    statusChangeFail: 'Failed to update status, please try again'
  },

  // 邀请对话框
  inviteDialog: {
    title: 'Invite Personal User',
    inviteeIdCard: 'Invitee ID Card',
    inviteePhone: 'Invitee Phone',
    inviteeInfo: 'Invitee Information:',
    refreshQuery: 'Refresh Query',
    queryAccount: 'Query Invitee Account',
    nickname: 'Nickname',
    realName: 'Real Name',
    idCard: 'ID Card',
    phone: 'Phone',
    verifiedStatus: 'Verified Status',
    isAdmin: 'Is Admin',
    isSalesman: 'Is Salesman',
    verified: 'Verified',
    unverified: 'Unverified',
    verifying: 'Verifying',
    rejected: 'Rejected',
    yes: 'Yes',
    no: 'No',
    sendSmsCode: 'Send Verify Code',
    resendSmsCode: ' seconds to resend',
    verifyCode: 'Invitee Phone Verify Code',
    pleaseInputVerifyCode: 'Please input invitee phone verify code',
    confirmInvite: 'Confirm Invitee as Salesman',
    confirmInviteAdmin: 'Confirm Invitee as Admin',
    querySuccess: 'Query Success',
    queryFail: 'Failed to query user information, please try again',
    notFound: 'No matching user information found',
    pleaseFillForm: 'Please fill in the complete form information',
    pleaseFillIdCardAndPhone: 'Please fill in ID card and phone number first',
    pleaseQueryFirst: 'Please query invitee information first'
  },

  // 表单验证
  validation: {
    required: 'This field is required',
    idCardFormat: 'Please enter a valid ID card number',
    phoneFormat: 'Please enter a valid phone number',
    emailFormat: 'Please enter a valid email address',
    minLength: 'Length cannot be less than {min} characters',
    maxLength: 'Length cannot exceed {max} characters'
  }
}

